import { render, staticRenderFns } from "./index-pack-form.vue?vue&type=template&id=628eb218&scoped=true&"
import script from "./index-pack-form.vue?vue&type=script&lang=js&"
export * from "./index-pack-form.vue?vue&type=script&lang=js&"
import style0 from "./index-pack-form.vue?vue&type=style&index=0&id=628eb218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628eb218",
  null
  
)

export default component.exports